<template>
  <div style="width: 100%; height: 100%">
    <div class="basket-img-container">
      <i
        class="fa fa-info-circle"
        aria-hidden="true"
        @click="showPrompt = true"
      ></i>
      <img src="@/assets/baskets/1.jpg" @click="onSelectedItem" />
    </div>
    <!-- <md-dialog-alert
      :md-active.sync="showPrompt"
      class="prompt_dialog"
      :md-title="item.description"
      md-content="Officia incididunt dolor minim duis cillum duis est enim quis ipsum cupidatat."
      md-confirm-text="Close"
      @md-confirm="showPrompt = false"
    /> -->
    <BasketDetailDialog
      v-if="showPrompt"
      @onClose="showPrompt = false"
      :item.sync="item"
    ></BasketDetailDialog>
  </div>
</template>

<script>
import BasketDetailDialog from "./BasketDetailDialog.vue";

export default {
  name: "BasketImg",

  components: { BasketDetailDialog },
  props: {
    item: {
      required: true,
      type: Object,
    },
    index: {
      required: true,
      type: Number,
    },
  },

  data() {
    return { showPrompt: false };
  },

  methods: {
    onSelectedItem() {
      this.$emit("onSelectedBasket", this.item);
    },
  },
};
</script>

<style scoped>
.basket-img-container {
  width: 100%;
  height: 150px;
  background-color: #b9b7b7;
  border-radius: 3px;
  box-shadow: 2px 2px 5px 2px #8f8c8c9e;
  margin-bottom: 6px;
  position: relative;
}
i {
  position: absolute;
  right: 6px;
  top: 3px;
  font-size: 25px;
  color: #ff607f;
  cursor: pointer;
}
img {
  width: 100% !important;
  height: 100% !important;
  border-radius: 3px;
}
</style>
